import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import CharteredRateList from "./CharteredRateList";
import GetSvgIcon from "../../images/svglist";
import CharteredRateAddEdit from "./CharteredRateAddEdit";
import { CallApiGet, CallApiPost } from "../Helper/serviceApi";
import { SERVER_ERR_MSG } from "../Helper/Constants";
import { CH_SRVC_TYPE } from "../../ConfigConstants/ConfigConstants";
import { API_URI } from "../../ConfigConstants/UrlConstants";

const initModalConfig = {
  show: false,
  title: "",
};

const initAlertConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};

const rateObj = {
  custId: 0,
  rateId: 0,
  rateCode: "",
  serviceId: 0,
  serviceType: "",
  serviceUnitPrice: 0,
  charges: 0,
  thresholdType: 0,
  thresholdValue: 0,
  limitFrom: 0,
  limitTo: 0,
  unitType: 0,
  serviceInfo: "",
  remarks: "",
  isUpdated: false,
};

const initObj = {
  custId: 0,
  custName: "",
  custAcctCode: "",
  rate: [],
};

const CharteredRateConfigMain = () => {
  const [spinner, setSpinner] = useState(false);
  const [custList, setCustList] = useState([]);
  const [modalConfig, setModalConfig] = useState(
    Object.assign({}, initModalConfig)
  );

  const [alertConfig, setAlertConfig] = useState(
    Object.assign({}, initAlertConfig)
  );

  const [rateType, setrateType] = useState([]);

  const [charteredRateList, setCharteredRateList] = useState([]);
  const [selRate, setSelRate] = useState(Object.assign({}, initObj));
  const [chOptionValue, setChOptionValue] = useState(
    Object.assign({}, initObj)
  );
  const [error, setError] = useState({
    value: false,
    message: "",
  });
  const [vhclTypeOpt, setVhclTypeOpt] = useState();
  useEffect(() => {
    reploadAction();
    getChOptionValue();
    getAllVhclTypes();
  }, []);

  const hideAlert = () => {
    setAlertConfig({
      isSuccess: alertConfig.isSuccess,
      size: alertConfig.size,
      show: false,
      title: "",
      description: "",
    });
    reploadAction();
  };

  const processData = (data) => {
    return data.map((d) => {
      //WEIGHT
      d.pricePerWeight = d.rate.find(
        (r) => r.serviceId === CH_SRVC_TYPE.WEIGHT
      )?.serviceUnitPrice;
      //PIECES
      d.pricePerPiece = d.rate.find(
        (r) => r.serviceId === CH_SRVC_TYPE.PIECES
      )?.serviceUnitPrice;
      //MANPOWER
      d.manpowerPrice = d.rate.find(
        (r) => r.serviceId === CH_SRVC_TYPE.EXTRAMANPOWER
      )?.serviceUnitPrice;
      //TAILGATE
      d.tailgatePrice = d.rate.find(
        (r) => r.serviceId === CH_SRVC_TYPE.TAILGATE
      )?.serviceUnitPrice;

      return d;
    });
  };

  const reploadAction = async () => {
    setSpinner(true);
    Promise.all([
      CallApiGet(`${API_URI.GET_CUST_CH_RATE_CONFIG}/0`),
      CallApiGet("CustListDrpDwn"),
    ]).then(([custChRateConfig, custDrpDwn]) => {
      if (
        custChRateConfig.respCode === 200 ||
        custChRateConfig.respCode === 0
      ) {
        setCharteredRateList(processData(custChRateConfig.respData));
      } else {
        console.error(custChRateConfig.respMessage);
      }
      if (custDrpDwn.respCode === 200) {
        const respData = custDrpDwn.respData;
        setCustList(respData);
      } else {
        console.error(custDrpDwn.respMessage);
      }
    });
    setSpinner(false);
  };

  const openPopup = (boolData, popupTitle, popupDesc) => {
    setAlertConfig({
      isSuccess: boolData,
      size: "md",
      show: true,
      title: popupTitle,
      description: popupDesc,
    });
  };

  const handlePostApiCall = (resp, sucMsg) => {
    switch (resp.respCode) {
      case 200:
        openPopup(true, "SUCCESS", sucMsg);
        break;
      case 500:
        openPopup(false, "ERROR", resp.respMessage || SERVER_ERR_MSG);
        break;
      case 401:
        openPopup(
          false,
          "UNAUTHORIZED",
          "Sorry, you don't have the write permission!!"
        );
        break;
      case 99:
        openPopup(
          false,
          "ERROR",
          "Something went wrong. Please try after soemtime!!"
        );
      default:
        openPopup(false, "ERROR", resp.respMessage);
        break;
    }
  };
  const onSubmit = async (data) => {
    // const existingVT = new Set(
    //   data.vhclType.map(
    //     (item) => `${item.rateId}-${item.isUpdated}-${item.serviceId}`
    //   )
    // );
    // const existingOC = new Set(
    //   data.otherCharges.map(
    //     (item) => `${item.rateId}-${item.isUpdated}-${item.serviceId}`
    //   )
    // );
    // data.rate.forEach((item) => {
    //   const key = `${item.rateId}-${item.isUpdated}-${item.serviceId}`;
    //   if (
    //     item.serviceId === CH_SRVC_TYPE.VHCLTYPE &&
    //     item.rateId > 0 &&
    //     !item.isUpdated &&
    //     !existingVT.has(key)
    //   ) {
    //     item.isDeleted = true;
    //     data.vhclType.push(item);
    //     existingVT.add(key);
    //   } else if (
    //     item.serviceId === CH_SRVC_TYPE.OTHERCHRG &&
    //     item.rateId > 0 &&
    //     !item.isUpdated &&
    //     !existingOC.has(key)
    //   ) {
    //     item.isDeleted = true;
    //     data.otherCharges.push(item);
    //     existingOC.add(key);
    //   }
    // });
    data.rate = [
      ...data.baseChg,
      ...data.pieces,
      ...data.vhclType,
      ...data.otherCharges,
      ...data.extService,
    ];
    if (!!data?.delSrvc) {
      data.rate = data.rate.concat(data.delSrvc);
    }
    const wgtUnitPrice = data.baseChg.find(
      (rt) => rt.serviceId === CH_SRVC_TYPE.WEIGHT
    );
    const vtUnitPrice = data.vhclType.find(
      (rt) => rt.serviceId === CH_SRVC_TYPE.VHCLTYPE && rt.serviceUnitPrice > 0
    );
    const piecesUnitPrice = data.pieces.find(
      (rt) => rt.serviceId === CH_SRVC_TYPE.PIECES && rt.serviceUnitPrice > 0
    );
    if (
      wgtUnitPrice?.serviceUnitPrice > 0 ||
      !!vtUnitPrice ||
      !!piecesUnitPrice
    ) {
      data.rate = data.rate.map((rt) => {
        rt.custId = data.custId;
        return rt;
      });
      setSpinner(true);
      const resp = await CallApiPost("SaveCharteredRateConfig", data.rate);
      handlePostApiCall(resp, "Chartered Rate processed successfully!!");
      handleCLose();

      setSpinner(false);
    } else {
      setError({
        value: true,
        message:
          "Please define unit price for weight or charge of atleast  one vehicle type or unit price for atleast one pieces",
      });
      setTimeout(() => {
        setError({
          value: false,
          message: "",
        });
      }, 10000);
    }
  };

  const handleBtnClick = (argData, argTitle) => {
    let copyRate = Object.assign({}, argData);
    copyRate.baseChg = copyRate.rate.filter((bData) =>
      [CH_SRVC_TYPE.WEIGHT].includes(bData.serviceId)
    );
    copyRate.vhclType = copyRate.rate.filter(
      (vdata) =>
        vdata.serviceId === CH_SRVC_TYPE.VHCLTYPE && vdata.serviceUnitPrice > 0
    );
    copyRate.otherCharges = copyRate.rate.filter(
      (odata) =>
        odata.serviceId === CH_SRVC_TYPE.OTHERCHRG && odata.serviceUnitPrice > 0
    );
    copyRate.pieces = copyRate.rate.filter(
      (odata) => odata.serviceId === CH_SRVC_TYPE.PIECES
    );
    copyRate.extService = copyRate.rate.filter((bData) =>
      [CH_SRVC_TYPE.EXTRAMANPOWER, CH_SRVC_TYPE.TAILGATE].includes(
        bData.serviceId
      )
    );
    setSelRate(copyRate);
    setModalConfig({
      show: true,
      title: argTitle,
    });
  };

  const handleCLose = () => {
    setSelRate(Object.assign({}, chOptionValue));
    setModalConfig({
      show: false,
      title: "",
    });
  };
  const getChOptionValue = async () => {
    setSpinner(true);
    const data = await CallApiGet("CharteredOptionValue");
    if (data.respCode === 200) {
      let serviceArr = data.respData;
      const copyObj = {
        custId: 0,
        custName: "",
        custAcctCode: "",
        rate: serviceArr,
      };
      setChOptionValue(copyObj);
    } else {
      console.error(data.respMessage);
    }
    setSpinner(false);
  };
  const getAllVhclTypes = async () => {
    setSpinner(true);
    const data = await CallApiGet("getAllVhclTypes");
    if (data.respCode === 200) {
      setVhclTypeOpt(data.respData);
    } else {
      console.error(data.respMessage);
    }
    setSpinner(false);
  };

  return (
    <>
      <Layout
        spinnershow={spinner}
        alertConfig={alertConfig}
        hideAlert={hideAlert}
      >
        <div className="clearfix border-bottom pb-2 mb-2">
          <div className="float-start">
            <div className="section-title mt-1">
              Customer Rate Configuration{" "}
            </div>
          </div>
          <div className="float-end d-flex align-items-center">
            <div className="mt-1">
              <button
                className="btn btn-outline-secondary theme-violet text-nowrap"
                type="button"
                onClick={() => handleBtnClick(chOptionValue, "ADD Rate")}
              >
                {GetSvgIcon("PlusCircle")} Add Rate
              </button>
            </div>
          </div>
        </div>
        <CharteredRateList
          handleAction={handleBtnClick}
          charteredRateList={charteredRateList}
        />
        <CharteredRateAddEdit
          modalConfig={modalConfig}
          vhclTypeOpt={vhclTypeOpt}
          onHide={handleCLose}
          custList={custList}
          rateType={rateType}
          error={error}
          setError={setError}
          selRate={selRate}
          onSubmit={onSubmit}
        />
      </Layout>
    </>
  );
};

export default CharteredRateConfigMain;
